import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { ClinicalItemService } from "./clinical-item.service";
import { IClinicalItem } from "./iclinical-item";

@Injectable({
    providedIn: 'root'
})
export class ClinicalItemResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _clinicalItem: ClinicalItemService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, clinicalItems: IClinicalItem[] }>> {
        const subcategory = Number(route.paramMap.get('id'));
        const category = Number(route.paramMap.get('categoryid'));

        var data = {
            categoryId: category,
            subcategoryID: subcategory,
            pageNumber: 0,
            pageSize: 100,
        };
        return this._clinicalItem.getClinicalItem(data);
    }
}